// 判断是否是PC端
import Vue from 'vue'
import axios from 'axios'
import getInfo from './getInfo'

export const isPC = () => {
  if(window.self !== window.top) return true
  const sUserAgent = window.navigator.userAgent.toLowerCase()
  const bIsIpad = sUserAgent.indexOf('ipad') > -1
  const bIsIphoneOs = sUserAgent.indexOf('iphone') > -1
  const bIsMidp = sUserAgent.indexOf('midp') > -1
  const bIsUc7 = sUserAgent.indexOf('rv:1.2.3.4') > -1
  const bIsUc = sUserAgent.indexOf('ucweb') > -1
  const bIsAndroid = sUserAgent.indexOf('android') > -1
  const bIsCE = sUserAgent.indexOf('windows ce') > -1
  const bIsWM = sUserAgent.indexOf('windows mobile') > -1
  return !(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)
}
export const browserAgent = () => {
  return window.navigator.userAgent.toLowerCase()
}

// 判断是否是iPhone
export const isiOS = () => {
  const u = window.navigator.userAgent
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
}

// 判断是否是Android
export const isArd = () => {
  const u = window.navigator.userAgent
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
}

// 判断是否是鸿蒙
export const isHM = () => {
  const u = window.navigator.userAgent
  return u.indexOf('OpenHarmony') > -1;
}

// 判断是否是safari
export const isSafari = () => {
  const u = window.navigator.userAgent.toLowerCase()
  return u.indexOf('safari') > -1
}

// 判断是否是iPad
export const isiPad = () => {
  const u = window.navigator.userAgent.toLowerCase()
  return u.indexOf('ipad') > -1
}

// 判断IOS美信是否启用WKWebview内核
export const isWKCordova = () => {
  const u = window.navigator.userAgent
  return u.indexOf('WKCordova') > -1
}

// 判断是否美信登录
export const isMideaConnect = () => {
  const explorer = window.navigator.userAgent
  // 有meixin的标识且token存在才判断为内部平台，否则为第三方平台
  // return true
  return (explorer.toLowerCase().indexOf('mideaconnect') > -1 ||
    explorer.toLowerCase().indexOf('electron') > -1)
}

// 是否微信浏览器
export const isWeixinBrowser = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  return /micromessenger/i.test(ua)
}

function transParams (params) {
  if (params instanceof Object) {
    let queryStr = '?'
    Object.keys(params).forEach(key => {
      queryStr = queryStr + key + '=' + params[key] + '&'
    })
    return queryStr.substr(0, queryStr.length - 1)
  } else {
    return ''
  }
}

function requestByUrl (url, params, option) {
  option = option || {}
  console.log('第一个option', option)
  let type = 'get'
  if (Object.prototype.hasOwnProperty.call(option, 'method')) {
    type = option.method.toLowerCase()
    delete option.method
  }
  console.log('第二个option', option)
  if (type === 'jsonp') {
    return Vue.http.jsonp(url, {
      params:{
        ...params,
        accessToken: option.headers && option.headers.accessToken,
      },
    })
  } else if (type === 'get') {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: url + transParams(params),
        headers: option.headers || {}
      })
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  } else if (type === 'post') {
    return new Promise((resolve, reject) => {
      axios(url, {
        method: 'POST',
        headers: option.headers || {},
        data: params
      })
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  } else {
    console.log('出错了')
  }
}

export const requestByMethod = (methodUrl, params, option) => {
  return requestByUrl(methodUrl, params, option)
}

// 随机生成一个唯一性的uuid,
export const getUUID = (len, radix) => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const uuid = []
  let uidStr = window.sessionStorage.getItem('mideaUid')
  if (!uidStr) {
    radix = radix || chars.length
    if (len) {
      for (let i = 0; i < len; i++) {
        uuid[i] = chars[0 | Math.random() * radix]
      }
    } else {
      let r
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
      uuid[14] = '4'
      for (let i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16
          uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
        }
      }
    }
    uidStr = uuid.join('')
    window.sessionStorage.setItem('mideaUid', uidStr)
  }
  return uidStr
}

/**
 * 函数节流
 * @param fn
 * @param interval
 * @returns {Function}
 * @constructor
 */
export const Throttle = (fn, t) => {
  let last
  let timer
  const interval = t || 500
  return function () {
    const args = arguments
    const now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        last = now
        fn.apply(this, args)
      }, interval)
    } else {
      last = now
      fn.apply(this, args)
    }
  }
}

export const getCookie = (cName) => {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(cName + '=')
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1
      let cEnd = document.cookie.indexOf(';', cStart + 1)
      if (cEnd === -1) cEnd = document.cookie.length
      return unescape(document.cookie.substring(cStart, cEnd))
    }
  }
  return ''
}

export const getCookieOfToken = (cName) => {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(cName + '=TV')
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1
      let cEnd = document.cookie.indexOf(';', cStart)
      if (cEnd === -1) cEnd = document.cookie.length
      return unescape(document.cookie.substring(cStart, cEnd))
    }
  }
  return ''
}


export const request = (url, params, option) => {
  // 先从底座获取重要数据(ssoToken、appKey)
  return new Promise((resolve) => {
    // TODO
    // deviceready
    if (isMideaConnect() && !isPC()) {
      Promise.all([getInfo.getUserToken(), getInfo.getDeviceInfo()]).then(([ssoToken, appKey]) => {
        sessionStorage.setItem('token', ssoToken)
        console.log('手机端预测是走这里')
        console.log(ssoToken)
        console.log(appKey)
        resolve(requestByMethod(url, params, {
          method: option.method,
          headers: { accessToken: ssoToken, appKey: appKey }
        }))
      })
    } else if (isMideaConnect() && isPC()) {
      const ssoToken = getCookieOfToken('token')
      resolve(requestByMethod(url, params, {
        method: option.method,
        headers: { accessToken: ssoToken, appKey: option.appKey }
      }))
    } else {
      resolve(requestByMethod(url, params, {
        method: option.method,
        headers: { accessToken: option.identification === 'admin' && option.ssoToken, appKey: option.appKey }
      }))
    }
  })
}
